<template>
  <div>
    <v-dialog fullscreen hide-overlay lazy v-model="dialog">
      <v-card>
        <v-toolbar
          :style="
            tabEvents && drawer && !isMobile
              ? 'margin-left:260px;width: auto;'
              : ''
          "
          color="primary"
        >
          <v-toolbar-title>
            <p class="white--text" style="margin-bottom:0">
              <v-toolbar-side-icon
                v-if="tabEvents && !drawer"
                @click.stop="drawer = !drawer"
                dark
                style="margin: 0;"
              ></v-toolbar-side-icon>
              {{ getUserOrTeam.toUpperCase() }}
            </p>

            <small class="white--text">{{
              `${match.time || ''} ${dateFormat(match.date) || ''} - ${
                match.locationName ? match.locationName.name : ''
              }`
            }}</small>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-if="canScore" bottom left :close-on-content-click="false">
              <template #activator="{ on: menu }">
                <v-tooltip bottom>
                  <template #activator="{ on: tooltip }">
                    <v-btn dark icon v-on="{ ...tooltip, ...menu }">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('judges') }}</span>
                </v-tooltip>
              </template>
              <v-list style="overflow-y: hidden">
                <v-list-tile>
                  <v-flex xs12>
                    <v-select
                      v-model="judgeId"
                      :items="judges"
                      :label="$t('judges')"
                      auto-select-first
                    >
                      <template v-slot:selection="data">{{
                        data.item.text
                      }}</template>
                      <template v-slot:item="data">
                        <v-list-tile-avatar>
                          <img :src="data.item.photo" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="data.item.text"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-select>
                  </v-flex>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn
              v-if="judgeId"
              icon
              dark
              :loading="syncScoreLoading"
              :disabled="isScoreSync"
              @click="syncScore"
            >
              <v-icon>sync</v-icon>
              <span
                class="v-badge__badge status"
                :class="!isScoreSync ? 'error' : 'success'"
              ></span
            ></v-btn>

            <v-btn icon dark :loading="refreshLoading" @click="refresh">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn @click="close()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-tabs
          :style="tabEvents && drawer && !isMobile ? 'margin-left:260px' : ''"
          color="primary"
          dark
          show-arrows
          v-model="tab"
        >
          <template v-if="match && match._id && act && act._id">
            <v-tab @click="tabEvents = false" active-class="secondary">{{
              $t('information')
            }}</v-tab>
            <template v-if="dialog">
              <template v-for="(category, index) in categoryAspectList">
                <v-tab
                  @click="tabEvents = false"
                  active-class="secondary"
                  :key="index + 400"
                  >{{ `${category.name} ${category.objectName}` }}</v-tab
                >
              </template>
            </template>
            <template v-if="canScore">
              <v-tab @click="tabEvents = false" active-class="secondary">{{
                $t('result')
              }}</v-tab>
            </template>
            <template v-if="match.video || match.youtubeVideo">
              <v-tab
                @click="
                  () => {
                    tabEvents = true
                    drawer = true
                  }
                "
                active-class="secondary"
                >{{ $t('video') }}</v-tab
              >
            </template>
            <template v-if="viewStats">
              <v-tab @click="tabEvents = false" active-class="secondary">{{
                $t('stats')
              }}</v-tab>
            </template>
          </template>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-progress-linear
            :active="!match || !match._id || !act || !act._id"
            height="3"
            :indeterminate="true"
          ></v-progress-linear>

          <template v-if="match && match._id && act && act._id">
            <v-tab-item>
              <tab-information
                :matchType="matchType"
                :edit="canScore"
              ></tab-information>
            </v-tab-item>
            <template v-if="dialog && judgeId && canScore && act && match">
              <v-tab-item
                v-for="(category, index) in categoryAspectList"
                :key="index + 100"
              >
                <tab-individual
                  :categoryAspect="category"
                  :matchType="matchType"
                  :judgeId="judgeId"
                  :score="score"
                  :edit="edit && !finalized"
                ></tab-individual>
              </v-tab-item>
            </template>
            <template v-if="canScore">
              <v-tab-item>
                <tab-results
                  :matchType="matchType"
                  :finalized="finalized"
                  :judgeId="judgeId"
                  :edit="edit"
                  :isScoreSync="isScoreSync"
                  :syncScoreLoading="syncScoreLoading"
                  @syncScore="syncScore"
                ></tab-results>
              </v-tab-item>
            </template>
            <template v-if="match.video || match.youtubeVideo">
              <v-tab-item>
                <tab-events
                  v-if="tabEvents"
                  :drawer.sync="drawer"
                  :edit="canScore"
                ></tab-events>
              </v-tab-item>
            </template>
            <template v-if="viewStats">
              <v-tab-item>
                <tab-stats
                  :match-type="matchType"
                  :can-score="canScore"
                ></tab-stats>
              </v-tab-item>
            </template>
          </template>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import tabIndividual from './tabIndividual'
import tabResults from './tabResults'
import tabInformation from './tabInformation'
import tabEvents from './tabEvents'
import tabStats from './tabStats'
import { dateFormat, timeFormat } from '../../../helpers/dateHelper'

export default {
  name: 'MatchView',
  components: {
    tabIndividual,
    tabResults,
    tabInformation,
    tabEvents,
    tabStats
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tab: 0,
      tabEvents: false,
      drawer: true,
      judgeId: '',
      refreshing: false,
      syncScoreLoading: false,
      refreshLoading: false
    }
  },
  mounted() {
    this.setJudge()
  },
  methods: {
    ...mapActions({
      setOneByScore: 'acts/setOneByScore',
      setUpdateMatch: 'matches/setUpdate',
      getOne: 'matches/setOne',
      syncCurrentScore: 'matches/syncCurrentScore'
    }),
    close() {
      this.tabEvents = false
      this.drawer = true
      this.dialog = false
      this.judgeId = ''
    },
    searchResultForTab(idCategory) {
      let listCategory = this.aspectByCategory(idCategory)
      let aspectRelated = listCategory.map(item =>
        this.aspectByType(idCategory, item.typeAspect)
      )
      return aspectRelated
    },
    aspectByCategory(category) {
      let act = this.act
      let typeAspects = []
      this.typeAspectList.forEach(type => {
        let aspects = this.aspectsByCategoryAndType(category._id, type._id)
        if (aspects.length) typeAspects.push({ ...type, aspects })
      })
      let aspectsByCategory = {
        ...category,
        typeAspects
      }

      return aspectsByCategory
    },
    aspectsByCategoryAndType(idCategory, idType) {
      let me = this
      if (!this.act || !this.act.aspects) {
        return []
      }
      let aspectList = this.act.aspects.filter(item => {
        return item.categoryAspect === idCategory && item.typeAspect === idType
      })
      aspectList = aspectList.sort((a, b) => a.order - b.order)
      let results = aspectList.map(aspectRel => {
        let searchAspect = this.aspects.find(
          aspect => aspect._id === aspectRel.aspectId
        )
        if (!searchAspect) return

        return {
          aspectRelId: aspectRel._id,
          name: searchAspect.name,
          typeScore: searchAspect.typeScore,
          untilSelect: searchAspect.untilSelect,
          score: 0
        }
      })
      return results
    },

    getElements(array) {
      return array.map(item => {
        return {
          _id: item._id,
          name: this.getName(item.name)
        }
      })
    },

    timeFormat(time) {
      return timeFormat(time, false)
    },
    dateFormat(date) {
      return dateFormat(date, false)
    },
    async refresh() {
      try {
        if (!this.match || !this.match._id) return
        this.refreshing = true
        this.refreshLoading = true
        await Promise.all([
          this.setOneByScore({
            actId: this.match.actId,
            matchId: this.match._id
          }),
          this.getOne(this.match._id)
        ])
      } finally {
        this.refreshing = false
        this.refreshLoading = false
      }
    },
    async syncScore() {
      try {
        if (!this.match || !this.match._id || !this.scoreId) return
        this.syncScoreLoading = true
        await this.syncCurrentScore()
        this.refresh()
      } finally {
        this.syncScoreLoading = false
      }
    },
    setJudge() {
      if (this.match && this.match.judges && this.match.judges.length) {
        if (this.match.judges.includes(this.authUser._id)) {
          this.judgeId = this.authUser._id
        } else if (this.judgeId && !this.match.judges.includes(this.judgeId)) {
          this.judgeId = this.match.judges[0]
        }
      } else {
        this.judgeId = ''
      }
    }
  },
  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      match: state => state.matches.matchSelected,
      scoreId: state => state.matches.scoreId,
      aspects: state => state.aspects.list,
      listStadiums: state => state.stadiums.listStadiums,
      listSelectUsers: state => state.users.listSelectUsers,
      listSelectTeams: state => state.teams.listSelectTeams,
      listTournaments: state => state.tournaments.list,
      authUser: state => state.authentication.user,
      tournament: state => state.tournaments.selected,
      isScoreSync: state => state.matches.isScoreSync,
      pendingAspects: state => state.matches.pendingAspects,
      pendingFaults: state => state.matches.pendingFaults,
      categories: state => state.acts.categories
    }),
    score() {
      return this.act.scores.find(score => score._id == this.scoreId)
    },
    currentAspects() {
      return this.pendingAspects[this.scoreId] || []
    },
    currentFaults() {
      return this.pendingFaults[this.scoreId] || []
    },
    matchType() {
      if (!this.match || !this.match.type) return ''
      let type = ''
      if (this.match.type == 'user') type = 'user'
      else if (this.match.type == 'tournament') {
        if (
          this.tournament &&
          (this.tournament.type == 'users' ||
            this.tournament.type == 'usersTeams')
        )
          type = 'user'
        else if (this.tournament && this.tournament.type == 'teams')
          type = 'team'
      } else if (this.match.type == 'friendly') type = 'team'
      return type
    },
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.$emit('close', value)
        }
      }
    },
    categoryAspectList() {
      let match = this.match
      if (!this.judgeId || !this.canScore) {
        return []
      }

      let results = []
      this.categories.forEach((category, index) => {
        if (this.matchType == 'user') {
          results.push({
            ...category,
            objectId: match.user,
            objectName: '',
            objectTitle: match.userName ? match.userName.name : ''
          })
        } else {
          let isConclusion = index == this.categories.length - 1

          let homeTeamItem
          let visitorTeamItem

          if (match.homeTeamId) {
            homeTeamItem = {
              ...category,
              objectId: match.homeTeamId,
              objectName: this.$t('homeTeamTitle'),
              objectTitle: match.homeTeam
            }
          }
          if (match.visitorTeamId) {
            visitorTeamItem = {
              ...category,
              objectId: match.visitorTeamId,
              objectName: this.$t('visitorTeamTitle'),
              objectTitle: match.visitorTeam
            }
          }
          if (homeTeamItem) {
            let item =
              isConclusion && visitorTeamItem ? visitorTeamItem : homeTeamItem
            results.push(item)
          }
          if (visitorTeamItem) {
            let item =
              isConclusion && homeTeamItem ? homeTeamItem : visitorTeamItem
            results.push(item)
          }
        }
      })

      return results
      // .map(category => {
      //   let scoreFault = [...this.currentFaults, ...this.score.faults].find(
      //     fault =>
      //       fault.objectId == category.objectId && fault.judgeId == this.judgeId
      //   )
      //   const fault = scoreFault
      //     ? { ...scoreFault }
      //     : {
      //         seriousFaults: 0,
      //         smallFaults: 0,
      //         warnings: 0,
      //         type: this.matchType,
      //         objectId: category.objectId,
      //         judgeId: this.judgeId
      //       }

      //   const typeAspects = category.typeAspects.map(typeAspect => ({
      //     ...typeAspect,
      //     aspects: typeAspect.aspects.map(aspect => {
      //       let aspectScored = [
      //         ...this.currentAspects,
      //         ...this.score.aspects
      //       ].find(
      //         aspectScored =>
      //           aspectScored.aspectRelId == aspect._id &&
      //           aspectScored.judgeId == this.judgeId &&
      //           aspectScored.objectId === category.objectId
      //       )
      //       return aspectScored
      //         ? { ...aspect, _id: undefined, ...aspectScored }
      //         : {
      //             ...aspect,
      //             _id: undefined,
      //             aspectRelId: aspect._id,
      //             type: this.matchType,
      //             objectId: category.objectId,
      //             judgeId: this.judgeId,
      //             score: 0
      //           }
      //     })
      //   }))
      //   return { ...category, typeAspects, fault }
      // })
    },
    typeAspectList() {
      let act = this.act
      if (!act || !act.typeAspects) {
        return []
      }
      let typeAspects = act.typeAspects.sort((a, b) => a.order - b.order)
      typeAspects = typeAspects.filter(type =>
        act.aspects.some(aspect => aspect.typeAspect == type._id)
      )
      let results = this.getElements(typeAspects)
      return results
    },
    aspectList() {
      if (!this.act || !this.act.typeAspects) {
        return []
      }
      let result = this.getElements(this.act.typeAspects)
      return result
    },
    judges() {
      if (!this.match || !this.match.judgesName) return []
      return this.match.judgesName.map(item => ({
        value: item._id,
        text: item.name,
        photo: process.env.VUE_APP_IMAGE_URL + item.photo
      }))
    },
    canScore() {
      let canScore = this.edit || this.isJudge
      return canScore
    },
    isJudge() {
      if (!this.match || !this.match.judges) return false
      return this.match.judges.includes(this.authUser._id)
    },
    viewStats() {
      if (this.canScore) return true
      else if (this.matchType == 'user') {
        return this.listSelectUsers.some(item => item.value == this.match.user)
      } else if (this.matchType == 'team' && this.match.teams) {
        return this.listSelectTeams.some(item =>
          this.match.teams.includes(item.value)
        )
      } else return false
    },
    getUserOrTeam() {
      if (!this.match || !this.match._id) return this.$t('messages.searching')
      let result = ''
      if (this.matchType == 'user' && this.match.userName)
        result = this.match.userName.name
      else if (this.matchType == 'team') {
        result = `${this.match.homeTeam || '*'} - ${this.match.visitorTeam ||
          '*'}`
      }
      return result
    },
    edit() {
      if (!this.match) return false
      let isCreator = this.isCreator(this.match)
      let isTournamentAdmin =
        this.match.tournamentId &&
        this.tournament &&
        this.can('edit', 'tournament', this.tournament)
      return (
        this.isAdmin ||
        isCreator ||
        isTournamentAdmin ||
        this.authUser._id == this.judgeId
      )
    },
    finalized() {
      if (!this.match || !this.match.judgesFinalized) return false

      return this.match.judgesFinalized.some(
        item => item.finalized && item.judgeId === this.judgeId
      )
    }
  },
  watch: {
    // tab: function(val) {
    //   this.refresh()
    // },
    modal: function(val) {
      this.tab = 0
    },
    'match.judges': {
      handler: function(val) {
        if (!this.refreshing) {
          this.setJudge()
        }
        this.refreshing = false
      },
      deep: true,
      inmediate: true
    },
    match: {
      handler: function(val) {
        if (!this.refreshing) {
          this.setJudge()
        }
        this.refreshing = false
      },
      deep: true,
      inmediate: true
    }
  }
}
</script>
<style lang="scss">
.status {
  width: 10px;
  height: 10px;
  top: 16px;
  right: 5px;
}
</style>
